'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { icons } from '@/assets/icons';
import { backgrounds } from '@/assets/materials';

import { CoreItem } from './bases/CoreLaunchPadCard';

const DATA: CoreItem[] = [
  {
    id: 1,
    icon: icons.ic_people_v2,
    description: 'Expert Guidance and Support',
  },
  {
    id: 2,
    icon: icons.ic_link_v2,
    description: 'Deep Strategic and Operation Experts',
  },
  {
    id: 3,
    icon: icons.ic_flash_v2,
    description: 'Comprehensive and tailored solutions geared for project success',
  },
];

export const WhyLFG = () => {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', sm: '80px' }}
      paddingY={{ xs: '40px', sm: '80px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}
      sx={{
        backgroundImage: `url(${backgrounds.hero_why_lfg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <Stack
        bgcolor={'#060912'}
        className={'bottom-cut'}
        height={{ xs: '12px', sm: '30px' }}
        position={'absolute'}
        top={0}
        zIndex={1}
        left={'50%'}
        width={{ xs: 'min(160px, 100%)', sm: 'min(616px, 100%)' }}
        sx={{ transform: 'translateX(-50%)' }}
      />
      <Stack gap={{ xs: 5, sm: 7 }} width={'min(1280px, 100%)'} zIndex={2}>
        <Typography
          component={'h2'}
          variant={'displayMedium'}
          className={'clip-text'}
          fontSize={{ xs: '24px', sm: '48px' }}
          lineHeight={{ xs: '32px', sm: '68px' }}
          sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
          WHY LFG?
        </Typography>
        <Stack
          width={'100%'}
          borderRadius={{ xs: 2, sm: 3 }}
          sx={{ backdropFilter: 'blur(5px)' }}
          bgcolor={'#0000004D'}>
          <Stack width={'100%'} alignItems={'center'} direction={{ xs: 'column', sm: 'row' }}>
            {DATA.slice(0, 2).map((item, index) => (
              <Stack
                height={{ xs: '200px', sm: '280px' }}
                width={'100%'}
                key={item.id}
                alignItems={'center'}
                justifyContent={'center'}
                gap={3}
                sx={{
                  borderRight: { xs: 'unset', sm: index === 0 ? '1px solid #FFFFFF0D' : 'unset' },
                  borderBottom: { xs: index === 0 ? '1px solid #FFFFFF0D' : 'unset' },
                  sm: 'unset',
                }}>
                <Image
                  width={48}
                  height={48}
                  src={item.icon}
                  alt={item.description ?? ''}
                  className={'w-[32px] h-[32px] sm:w-[48px] sm:h-[48px]'}
                />
                <Typography
                  className={'mix-blend'}
                  variant={'bodyLarge'}
                  color={'white'}
                  maxWidth={{ xs: '247px', sm: '360px' }}
                  textAlign={'center'}
                  fontSize={{ xs: '14px', sm: '18px' }}>
                  {item.description}
                </Typography>
              </Stack>
            ))}
          </Stack>
          <Stack
            height={{ xs: '200px', sm: '280px' }}
            alignItems={'center'}
            justifyContent={'center'}
            borderTop={'1px solid #FFFFFF0D'}>
            <Stack alignItems={'center'} justifyContent={'center'} gap={3}>
              <Image
                width={48}
                height={48}
                src={DATA[2]?.icon}
                alt={DATA[2]?.description ?? ''}
                className={'w-[32px] h-[32px] sm:w-[48px] sm:h-[48px]'}
              />
              <Typography
                className={'mix-blend'}
                variant={'bodyLarge'}
                color={'white'}
                maxWidth={{ xs: '247px', sm: '360px' }}
                textAlign={'center'}
                fontSize={{ xs: '14px', sm: '18px' }}>
                {DATA[2]?.description}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
